import { useLocation } from "react-router";
import { Check, Circle } from "lucide-react";

const MODULES: Record<string, { title: string; phase: string; intro: string; items: string[]; caveat?: string }> = {
  "/recetas": {
    title: "Recetas, órdenes y documentos",
    phase: "Fase 5",
    intro: "Borradores de recetas, órdenes de estudios, derivaciones, certificados e indicaciones post-operatorias, con revisión profesional.",
    items: [
      "Borrador → revisión → emisión → anulación, con trazabilidad",
      "Medicamento, principio activo, presentación, dosis, vía, frecuencia, duración",
      "Alertas de alergias y duplicidades como ayuda, nunca decisiones automáticas",
      "PDF con datos del profesional y plantillas",
      "Adapter para plataforma de receta electrónica inscripta en ReNaPDiS",
    ],
    caveat:
      "Las recetas electrónicas legalmente válidas (Ley 27.553, Decreto 345/2024) sólo se emiten a través de una plataforma registrada que valide al profesional en REFEPS. Hasta integrar una, COP genera documentos internos rotulados como no oficiales.",
  },
  "/facturacion": {
    title: "Caja, cobros y facturación",
    phase: "Fase 4",
    intro: "Presupuestos, cuentas corrientes, cobros y comprobantes electrónicos.",
    items: [
      "Presupuestos por plan de tratamiento, con aceptación del paciente",
      "Cobros con Mercado Pago (links, QR, cuotas) y webhooks firmados",
      "Pagos parciales, anticipos, saldos y devoluciones",
      "Cierre de caja por turno y sede",
      "Factura electrónica vía ARCA (homologación primero), CAE y notas de crédito",
    ],
    caveat: "La facturación real se habilita sólo después de homologar con ARCA y validar el tratamiento fiscal con el contador.",
  },
  "/inventario": {
    title: "Inventario e insumos",
    phase: "Fase 6",
    intro: "Control de insumos, lotes y vencimientos.",
    items: ["Stock por insumo y lote", "Consumo por prestación", "Alertas de mínimos y vencimientos", "Compras y proveedores"],
  },
  "/reportes": {
    title: "Reportes",
    phase: "Fase 6",
    intro: "Indicadores operativos y comerciales.",
    items: ["Ocupación por sillón y profesional", "Ausentismo (no-show)", "Conversión de reservas web", "Cobranza y presupuestos aceptados"],
  },
  "/configuracion": {
    title: "Configuración",
    phase: "Fase 2",
    intro: "Datos del consultorio, profesionales, horarios, prestaciones y equipo.",
    items: [
      "Datos de contacto, dirección y horarios públicos",
      "Profesionales, matrículas y prestaciones que atienden",
      "Horarios recurrentes, ausencias y feriados",
      "Duración y buffer por prestación; qué se reserva online",
      "Equipo y roles (Dirección, Recepción, Odontología, Facturación…)",
    ],
  },
};

export function Roadmap() {
  const { pathname } = useLocation();
  const m = MODULES[pathname] ?? MODULES["/configuracion"]!;
  return (
    <div className="page">
      <header className="toolbar">
        <div className="toolbar-title">
          <h1>{m.title}</h1>
          <p className="muted small">{m.phase} del plan de implementación</p>
        </div>
      </header>
      <div className="roadmap">
        <p className="lede">{m.intro}</p>
        <ul className="checklist">
          {m.items.map((i) => (
            <li key={i}>
              <Circle size={14} aria-hidden /> {i}
            </li>
          ))}
        </ul>
        {m.caveat && (
          <div className="notice notice-warn">
            <p>{m.caveat}</p>
          </div>
        )}
        <p className="muted small row gap-4 center">
          <Check size={14} aria-hidden /> Mientras tanto, los datos se cargan desde la consola de Firebase o el script de seed.
        </p>
      </div>
    </div>
  );
}
